module.exports = __webpack_public_path__ + "static/img/023多语言版本英语14.0fa4d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/023多语言版本英语14.jpg
// module id = OTK/
// module chunks = 0